import { createContext, useContext } from "react";
import Tour from "@/models/Tour";
import TourMembership, {
  hasTourPermission,
  TourPermission
} from "@/models/TourMembership";
import { tenantPath } from "@/app/routing/tourRoutes";

export interface TourContextValue {
  tour: Tour;
  membership?: TourMembership;
  isFlagship: boolean;
  can: (permission: TourPermission) => boolean;
  path: (path?: string) => string;
}

/**
 * Phase 0 contract only. A tenant-aware provider will populate this during the
 * routing rollout; no existing page behavior changes yet.
 */
export const TourContext = createContext<TourContextValue | null>(null);

export function useTourContext() {
  const context = useContext(TourContext);

  if (!context) {
    throw new Error("useTourContext must be used inside a tenant-aware TourContext provider.");
  }

  return context;
}

export function createTourContextValue(
  tour: Tour,
  membership: TourMembership | undefined,
  isFlagship: boolean
): TourContextValue {
  return {
    tour,
    membership,
    isFlagship,
    can: permission => hasTourPermission(membership, permission),
    path: path => (isFlagship ? path || "/" : tenantPath(tour.id, path))
  };
}
